export const PROCESSES_TABLE_NAME = 'processes';
export const PROCESSES_AGG_VIEW_NAME = 'processes_agg';
export const CONTEXT_TABLE_NAME = 'context_records';
